<template>
  <div class="background_index_team">
    <div style="height: 92vh">
      <div style="padding-top: 28vh">
        <p style="font-size: 22px;margin-bottom: 0.5vh;">Our Team</p>
        <p>————</p>
        <p style="font-size: 20px;margin-bottom: 0">Comprehensive analysis and insights lie</p>
        <p style="font-size: 20px;">at the heart of our investment process.</p>
        <p style="font-size: 12px;margin-bottom: 0">Based on years of in-depth assessments of numerous companies </p>
        <p style="font-size: 12px;margin-bottom: 0">in different industries,we are willing to provide </p>
        <p style="font-size: 12px;margin-bottom: 0">our portfolio companies with great assistance to accelerate </p>
        <p style="font-size: 12px;margin-bottom: 0">post-investment performance.SIG is dedicated to helping our</p>
        <p style="font-size: 12px;margin-bottom: 0"> entrepreneurs build successful companies by providing them</p>
        <p style="font-size: 12px;margin-bottom: 0">with capital, guidance, network and the best resources
          available.</p>
      </div>
      <div style="margin-top: 2vh">
        <a-button type="ghost">
          <router-link :to="'/team_en_m'">See More Team</router-link>
        </a-button>
      </div>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from "@ant-design/icons-vue/";

export default {
  name: 'Index_team_en_m',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {   //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}

</script>
<style scoped>
.background_index_team {
  background-image: url("../../../assets/background/index_team.jpg");
  height: 100vh;

  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}
</style>